import { Component, OnInit, Input } from '@angular/core';
import { MistService } from '@app/features/mists/shared/mist.service';

@Component({
    selector: 'app-mist-site-card',
    templateUrl: './site-card.component.html',
    styleUrls: ['./site-card.component.css'],
    standalone: false
})
export class MistSiteCardComponent implements OnInit {

    site: any;

    constructor(private mistService: MistService) { }

    ngOnInit() {}

    async getSite(storeNumber: string) {
        (await this.mistService.getSite(storeNumber)).toPromise().then( (site) => {
            this.site = site["message"];
            return this.site;
        });
    }

}